import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const sectionsAdapter = createEntityAdapter();

const initialState = sectionsAdapter.getInitialState({
	status: "idle",
	error: null,
});

const sectionsSlice = createSlice({
	name: "sections",
	initialState,
	reducers: {
		sectionsReceived(state, action) {
			sectionsAdapter.setAll(state, action.payload);
		},
	},
});

/*
ACTIONS
sections data can only ever be received via API
There are no actions to CRUD individual sections
*/
export const { sectionsReceived } = sectionsSlice.actions;

/*
SELECTORS
*/
export const { selectAll: selectAllSections, selectById: selectSectionById } =
	sectionsAdapter.getSelectors((state) => state.sections);

/*
CUSTOM SELECTORS
*/
export const selectSectionsError = (state) => state.sections.error;

export default sectionsSlice.reducer;
